import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { useForm } from 'react-hook-form';
import config from '../../../config';
import axios from 'axios';
import Alert from '@material-ui/lab/Alert';
import HistoryIcon from '@material-ui/icons/History';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    expiredContainer: {
      height: '200px',
      padding: '50px',
      textAlign: 'center'
    },
    expiredIcon: {
        fontSize: '45px'
    },
    expiredInstruction: {
        textAlign: 'center'
    }

}));
export default function PasswordReset({ onCancel, userData }) {
    const classes = useStyles();
    const API_URL = config.apiUrl;
    const userEmail = userData?.username;
    const { register, handleSubmit, reset, formState: { errors }, watch } = useForm({
        defaultValues: {
            userEmail,
        }
    });
    
    const [resetResponse, setResetResponse] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    
    const messages = { validate: 'New password and confirm password do not match' };
    const newPassword = watch('password');

    const comparePassword = (confirmPassword) => {
        if (newPassword !== confirmPassword)
            return false
    }

    const onResetPassword = async (resetPayload) => {
        try {
            setIsUpdate(true);
            setResetResponse(false);
            const response = await axios({
                method: 'post',
                url: API_URL + 'user/reset/password',
                data: resetPayload, //body
            })
            
            setIsUpdate(false);
            if (response.data) {
                setResetResponse(response.data)
            }
            
            
        } catch (error) {
            console.error(`Handling reset password failed. ${error}`);
            console.log({resetPayload})
        }
    }

    const url = window.location.protocol + '//' + window.location.host;


    return (
        userData === undefined ? 
        <Grid container direction={"row"} className={classes.expiredContainer} id={"reset_password_expired_container"} >
            <Grid >
                <HistoryIcon className={classes.expiredIcon}/>
                <h5>ACTIVATION LINK EXPIRED</h5>
                <p className={classes.expiredInstruction}>Your request to reset your password has expired or the link has already been used.</p>
                <Link href={url}>Sign In</Link>
            </Grid>
            
        </Grid>
        :
        <Grid container direction={"row"} spacing={3} id={"reset_password_container"} >


            <Grid item xs={12}>
                <TextField
                    //disabled
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="userEmail"
                    label="Email"
                    name="userEmail"
                    autoComplete="userEmail"
                    autoFocus
                    inputProps={{ readOnly: true }}
                    inputRef={register({ required: true })}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    type='password'
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="password"
                    label="Password"
                    name="password"
                    autoComplete="password"
                    autoFocus
                    inputRef={register({ required: true })}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    type='password'
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="confirmPassword"
                    label="Confirm Password"
                    name="confirmPassword"
                    autoComplete="confirmPassword"
                    inputRef={register({ validate: comparePassword })}
                    error={errors?.confirmPassword ? true : false}
                    helperText={errors?.confirmPassword ? messages[errors?.confirmPassword?.type] : ''}
                />
            </Grid>
            {resetResponse !== false && <Grid item xs={12}>
                {resetResponse.status && <Alert id={"reset_password_success"} severity="success">{resetResponse.message}. <a id={"login_link"} href={url}>Login now.</a></Alert>}
                {!resetResponse.status && <Alert id={"reset_password_error"} severity="error">{resetResponse.message}</Alert>}
            </Grid>}
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
                <Button onClick={onCancel} variant="contained" style={{ marginLeft: 10 }}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit(onResetPassword)} disabled={isUpdate} color="primary" variant="contained" style={{ marginLeft: 10 }}>
                    Submit
                </Button>
            </Grid>


        </Grid>
    )
}